module.exports = __webpack_public_path__ + "static/media/Head.8951c01c.jpg";